import { Injectable, inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { environment } from "../../../environments/environment";
import { Title, Meta } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class Seo {
  private doc = inject(DOCUMENT);
  private title = inject(Title);
  private meta = inject(Meta);

  canonicalLink!: HTMLLinkElement;

  constructor() {
    this.setMeta({ property: "og:site_name", content: environment.title });
  }

  setCanonicalURL(url: string) {
    const links: HTMLLinkElement[] = Array.from(
      this.doc.head.getElementsByTagName("link"),
    );
    if (Symbol.iterator in Object(links)) {
      [...links].forEach((link) => {
        if (link.getAttribute("rel") === "canonical") {
          this.canonicalLink = link;
        }
      });
    }
    if (!this.canonicalLink) {
      this.canonicalLink = this.doc.createElement("link");
    }
    this.canonicalLink.setAttribute("rel", "canonical");
    this.canonicalLink.setAttribute("href", environment.fullUrl + url);
    this.doc.head.appendChild(this.canonicalLink);
    this.setMeta({ property: "og:url", content: environment.fullUrl + url });
  }

  setTitle(title: string) {
    this.title.setTitle(title);
    this.setMeta({ property: "og:title", content: title });
  }

  addImage(url: string) {
    this.setImage(url);
  }

  setImage(url: string) {
    this.setMeta({ property: "og:image", content: url });
  }

  unsetImage() {
    this.unsetMeta({ property: "og:image" });
  }

  setDescription(description: string | undefined) {
    this.setMeta({ name: "description", content: description });
    this.setMeta({ property: "og:description", content: description });
  }

  unsetDescription() {
    this.unsetMeta({ name: "description" });
    this.unsetMeta({ property: "og:description" });
  }

  addMeta(meta: { property?: string; name?: string; content?: string }) {
    this.meta.addTag(meta);
  }

  setMeta(meta: { property?: string; name?: string; content?: string | number } | null) {
    if (meta) this.meta.updateTag(meta as any);
    // this.unsetMeta(meta);
    // this.addMeta(meta);
  }

  unsetMeta(meta: { property?: string; name?: string; content?: string | number } | null) {
    if (!meta) return;
    if (meta.name) {
      this.meta.removeTag("name='" + meta.name + "'");
    }
    if (meta.property) {
      this.meta.removeTag("property='" + meta.property + "'");
    }
  }

  private createDomElements(descriptions: Record<string, string>[], tag: string) {
    // console.log(tag, descriptions);
    for (const description of descriptions) {
      // console.log('description', description);
      const element = this.doc.createElement(tag);
      for (const key of Object.keys(description)) {
        element.setAttribute(key, description[key]);
      }
      if (!this.doc.head.contains(element)) {
        this.doc.head.appendChild(element);
      }
    }
  }
}
